module.exports = __webpack_public_path__ + "static/media/zebra02.c4366efd.png";